// extracted by mini-css-extract-plugin
module.exports = {"container":"Section-module--container--1TV5_","section":"Section-module--section--2nM98"};